var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgPlanning = function SvgPlanning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#414141"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.365 19.13h-4.006a.718.718 0 110-1.435h3.501l1.395-3.826H1.745l1.394 3.826H6.64a.718.718 0 110 1.434H2.635a.719.719 0 01-.675-.472l-1.917-5.26a.717.717 0 01.676-.963H22.28a.716.716 0 01.676.963l-1.917 5.26a.72.72 0 01-.675.472z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.574 22.955a.718.718 0 01-.711-.826l.83-5.39H7.307l.831 5.39a.717.717 0 01-.6.818.715.715 0 01-.82-.6L5.76 16.13a.717.717 0 01.71-.827h10.06a.718.718 0 01.71.828l-.958 6.217a.717.717 0 01-.71.607zm5.989-9.325a.718.718 0 01-.72-.718 5.511 5.511 0 00-2.645-4.676.716.716 0 01-.24-.986.72.72 0 01.988-.24c2.057 1.252 3.334 3.513 3.334 5.902a.717.717 0 01-.718.718z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.729,
    cy: 7.173,
    rx: 1.438,
    ry: 1.435
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 7.652a3.833 3.833 0 01-3.833-3.826 3.833 3.833 0 017.666 0A3.833 3.833 0 0111.5 7.652zm0-6.217a2.396 2.396 0 00-2.396 2.39 2.396 2.396 0 004.792 0 2.396 2.396 0 00-2.396-2.39zm7.188 12.434a.718.718 0 01-.72-.718 3.115 3.115 0 00-3.114-3.108H8.146A3.115 3.115 0 005.03 13.15a.718.718 0 01-1.437 0 4.553 4.553 0 014.552-4.543h6.708a4.553 4.553 0 014.552 4.543.718.718 0 01-.718.718z"
  }))));
};

export default SvgPlanning;